import { useState } from 'react';
import useFloorPlanGuiListData from 'modules/site-walk-gui/hooks/useFloorPlanGuiListData';
import { useParams } from 'react-router-dom';
import { CircularProgress } from '@hyperflake/react-ui-library';
import FloorPlanCustomizeGui from '../FloorPlanCustomizeGui/FloorPlanCustomizeGui';
import CreateFloorPlanGui from '../CreateFloorPlanGui/CreateFloorPlanGui';

const FloorPlanGuiViewer = () => {
    const { clientId, projectId } = useParams();
    const { floorPlansGui, isLoading, setData, refetch } = useFloorPlanGuiListData({ clientId, projectId });
    const [selectedIndex, setSelectedIndex] = useState(0);

    if (isLoading)
        return (
            <div className="mt-6 flex justify-center items-center min-h-[600px]">
                <CircularProgress />
            </div>
        );

    // Normalize: handle both a single object and an array
    const list = Array.isArray(floorPlansGui) ? floorPlansGui : floorPlansGui ? [floorPlansGui] : [];

    if (list.length === 0) return <CreateFloorPlanGui onSave={refetch} />;

    const current = {
        ...list[selectedIndex],
        levels: list[selectedIndex].levels ?? [],
    };

    return (
        <div className="flex flex-col mt-4">
            {/* Tab selector — only shown when there are multiple floor plans */}
            {list.length > 1 && (
                <div className="flex gap-1 px-4 pt-3 bg-[#0f172a] border-b border-white/10 overflow-x-auto">
                    {list.map((plan, index) => (
                        <button
                            key={plan._id}
                            onClick={() => setSelectedIndex(index)}
                            className={`px-4 py-2 text-xs font-semibold rounded-t transition-all whitespace-nowrap ${
                                selectedIndex === index
                                    ? 'bg-[#1e293b] text-white border border-b-0 border-white/10'
                                    : 'text-slate-500 hover:text-slate-300'
                            }`}
                        >
                            Floor Plan {index + 1}
                        </button>
                    ))}
                </div>
            )}

            <FloorPlanCustomizeGui
                clientId={clientId}
                projectId={projectId}
                siteWalkMediaId={current._id}
                floorPlansGui={current}
                // onSave={(updatedFloorPlanGui) => setData(updatedFloorPlanGui)}
                onSave={(updatedFloorPlanGui) => setData(updatedFloorPlanGui)}
            />
        </div>
    );
};

export default FloorPlanGuiViewer;
